<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">项目管理</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-button @click="addkf" type="primary">添加项目</a-button>
                <a-button type="danger" :disabled="disabled" @click="delusers">删除项目</a-button>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    :placeholder="tstext"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}" rowKey="id" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <span slot="action" slot-scope="text,record" class="operate">
                        <!-- <a href="javascript:;" @click="toedit(record.id)" style="margin-right:12px"><a-icon type="edit" /> 跟进</a> -->
                        <a href="javascript:;" @click="edituser(record.id)"><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;" @click="deluser(record.id)"><a-icon type="delete" /> 删除</a>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>


                </a-table>

                <!-- <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div> -->
            </a-spin>
        </div>

        <!-- 添加项目 -->
        <a-modal
        title="添加项目"
        :visible="addvisible"
        cancelText="取消"
        okText="确认"
        @ok="addhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="项目缩写">
                    <a-input v-model="title_sx"  v-decorator="['项目缩写', { rules: [{ required: true, message: '请输入项目缩写' }] }]" />
                </a-form-item>
                <a-form-item label="项目名称">
                    <a-input v-model="title"  v-decorator="['项目名称', { rules: [{ required: true, message: '请输入项目名称' }] }]" />
                </a-form-item>
                <a-form-item label="联系人">
                    <a-input v-model="username"  v-decorator="['联系人', { rules: [{ required: true, message: '请输入联系人姓名' }] }]" />
                </a-form-item>
                <a-form-item label="手机号码">
                    <a-input v-model="telephone"  />
                </a-form-item>
                <a-form-item label="公众号原始id">
                    <a-input v-model="OriginalID"  />
                </a-form-item>
                <a-form-item label="AppID">
                    <a-input v-model="AppID"  />
                </a-form-item>
                <a-form-item label="AppSecret">
                    <a-input v-model="AppSecret"  />
                </a-form-item>
                <a-form-item label="TOKEN">
                    <a-input v-model="token"  />
                </a-form-item>
                <a-form-item label="EncodingAESKey">
                    <a-input v-model="EncodingAESKey"  />
                </a-form-item>
                <a-form-item label="ServerUrl">
                    <a-input v-model="serverUrl"  />
                </a-form-item>
                <a-form-item label="排序">
                    <a-input v-model="sort"  />
                </a-form-item>

            </a-form>
        </a-modal>

        <!-- 编辑项目 -->
        <a-modal
        title="编辑项目"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="edithandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="项目缩写">
                    <a-input v-model="editinfo.title_sx"   />
                </a-form-item>
                <a-form-item label="项目名称">
                    <a-input v-model="editinfo.title" />
                </a-form-item>
                <a-form-item label="联系人">
                    <a-input v-model="editinfo.username"   />
                </a-form-item>
                <a-form-item label="手机号码">
                    <a-input v-model="editinfo.telephone"  />
                </a-form-item>
                <a-form-item label="公众号原始id">
                    <a-input v-model="editinfo.OriginalID"  />
                </a-form-item>
                <a-form-item label="AppID">
                    <a-input v-model="editinfo.AppID"  />
                </a-form-item>
                <a-form-item label="AppSecret">
                    <a-input v-model="editinfo.AppSecret"  />
                </a-form-item>
                <a-form-item label="TOKEN">
                    <a-input v-model="editinfo.TOKEN"  />
                </a-form-item>
                <a-form-item label="EncodingAESKey">
                    <a-input v-model="editinfo.EncodingAESKey"  />
                </a-form-item>
                <a-form-item label="ServerUrl">
                    <a-input v-model="editinfo.serverUrl"  />
                </a-form-item>
                <a-form-item label="排序">
                    <a-input v-model="editinfo.sort"  />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import { Modal } from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'id',key: 'id',width:100},
    {title: '项目缩写',dataIndex: 'title_sx',key: 'title_sx'},
    {title: '项目名称',dataIndex: 'title',key: 'title'},
    {title: '联系人',dataIndex: 'username',key: 'username'},
    {title: '排序',dataIndex: 'sort',key: 'sort'},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' }},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' }},
]
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            editvisible:false,
            tstext:"项目",
            tablex:'100%',

            searchtext:"",
            form: this.$form.createForm(this, { name: 'coordinated' }),
            username:"",

            delids:[],
            disabled:true,

            editid:"",
            editinfo:"",
            title_sx:"",
            title:"",
            username:"",
            telephone:"",
            sort:0,

            OriginalID:"",
            AppID:"",
            AppSecret:"",
            token:"",
            EncodingAESKey:"",
            serverUrl:""
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    mounted(){
        this.fetch()
        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };
    },
    methods:{

        // 搜索
        onSearch(){

        },

        // 删除
        onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
            // console.log('selectedRowKeys changed: ', selectedRowKeys);
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        deluser(id){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        handok(id){
            this.$axios.post('/api/system/delitem',{
                imids:id
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.disabled=true
                    this.$message.success('删除成功');
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 编辑项目
        edituser(id){
            this.editid=id
             this.$axios.post('/api/system/itempage',{
                imid:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editinfo=res.data.data
                    this.editvisible=true
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        edithandleOk(){
           this.$axios.post('/api/system/edititem',{
                imid:this.editid,
                title_sx:this.editinfo.title_sx,
                username:this.editinfo.username,
                title: this.editinfo.title,
                telephone:this.editinfo.telephone,
                sort:this.editinfo.sort,
                AppSecret:this.editinfo.AppSecret,
                AppID:this.editinfo.AppID,
                OriginalID:this.editinfo.OriginalID,
                TOKEN:this.editinfo.TOKEN,
                EncodingAESKey:this.editinfo.EncodingAESKey,
                serverUrl:this.editinfo.serverUrl
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            }) 
        },

        // 添加项目
        addkf(){
          this.addvisible=true
        },
        addhandleOk(){
            this.$axios.post('/api/system/additem',{
                title_sx:this.title_sx,
                username:this.username,
                title: this.title,
                telephone:this.telephone,
                sort:this.sort,
                AppSecret:this.AppSecret,
                AppID:this.AppID,
                OriginalID:this.OriginalID,
                TOKEN:this.token,
                EncodingAESKey:this.EncodingAESKey,
                serverUrl:this.serverUrl
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.addvisible=false
                    this.$message.success(res.data.msg); 
                    this.title_sx="",
                    this.username="",
                    this.title="",
                    this.telephone="",
                    this.sort="",
                    this.AppSecret="",
                    this.AppID="",
                    this.OriginalID="",
                    this.token="",
                    this.EncodingAESKey="",
                    this.serverUrl=""
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        handleCancel(){
            this.addvisible=false
            this.editvisible=false
        },
        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/system/itemlist',{
                pagesize: this.size,
                page:this.currentpage,
                sources:this.sources,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/project.vue